import React from "react";

export const QuestionContent = (props) =>
    (<div>
        <p className='hint'>{props.children}</p>
        <input className='uk-input' type='text' onChange={e => props.setAnswer(e.target.value)}/>
        <p className='uk-text-muted'>Answer: {props.answer}</p>
    </div>)